import {
  EditContext,
  EditingStoppedReason,
} from '@efdigital/ll-admin-v2/components/edit-context.gts';
import { EditLtiConsumedToolDeployment } from '@efdigital/ll-admin-v2/components/lti/edit-lti-consumed-tool-deployment.gts';
import { DataTypeLti } from '@efdigital/ll-admin-v2/data/data-types/lti';
import { deepRollback } from '@efdigital/ll-admin-v2/data/deep-rollback';
import type { LtiConsumedToolDeployment } from '@efdigital/ll-admin-v2/data/types/lti';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { Store } from '@warp-drive/core';
import BsModal from 'ember-bootstrap/components/bs-modal';

interface Signature {
  Args: {
    platformId: string;
    consumedToolId: string;
    onSaved: (deployment: LtiConsumedToolDeployment) => void;
  };
  Blocks: {
    trigger: [openModal: () => void];
  };
}

export default class LtiCreateDeploymentModal extends Component<Signature> {
  @service declare store: Store;

  @tracked visible = false;
  @tracked deployment?: LtiConsumedToolDeployment;

  openModal = (): void => {
    this.deployment = this.store.createRecord<LtiConsumedToolDeployment>(
      DataTypeLti.ConsumedToolDeployment,
      {
        consumedToolId: this.args.consumedToolId,
        platformDeploymentId: 'TODO',
        resourceLinkClaimPath: null,
        isActive: false,
      }
    );
    this.visible = true;
  };

  closeModal = (): void => {
    this.visible = false;
    this.deployment = undefined;
  };

  handleEditingStopped = (reason: EditingStoppedReason) => {
    if (reason === EditingStoppedReason.Saved && this.deployment) {
      this.args.onSaved(this.deployment);
      this.closeModal();
      return;
    }

    if (reason !== EditingStoppedReason.Cancelled && this.deployment) {
      deepRollback(this.deployment, this.store);
    }

    this.closeModal();
  };

  <template>
    {{yield this.openModal to="trigger"}}
    <BsModal
      @open={{this.visible}}
      @onHidden={{this.closeModal}}
      @size="lg"
      @backdropClose={{false}}
      as |modal|
    >
      <modal.header>
        <h2 class="modal-title h5">Add tool deployment</h2>
      </modal.header>
      <modal.body>
        <p class="text-muted">
          Enter the deployment ID from the customer's LMS.<br />Use
          <code>TODO</code>
          if the customer has not provided the value yet.
        </p>

        {{#if this.deployment}}
          <EditContext
            @onEditingStopped={{this.handleEditingStopped}}
            as |context|
          >
            <EditLtiConsumedToolDeployment
              @item={{this.deployment}}
              @platformId={{@platformId}}
              @consumedToolId={{@consumedToolId}}
              @context={{context}}
              @initialState="edit"
            />
          </EditContext>
        {{/if}}
      </modal.body>
    </BsModal>
  </template>
}
